import React from "react";
import logo from "../../assets/head.svg";
import "./CustomerRegister.scss";
import Button from "../../components/button/Button";
import { useNavigate } from "react-router-dom";
import base from "../../assets/base.svg";
import logoIC from "../../assets/logo.svg";

const CustomerRegister: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className='CustomerRegister'>
      <div className='header-tab'>Customer Registration</div>
      <div className='content-register'>
        <div
          className='left-content-register'
          style={{ backgroundImage: `url(${base})` }}
        >
          <div className='left-logo-container'>
            <img alt='' src={logoIC} className='logoic-img' />
          </div>
          <div className='left-text-container'>
            The multipurpose tool you need to succeed in business
          </div>
        </div>
        <div className='right-content-register'>
          <div className='regitser-container'>
            <div className='register-header'>
              <div className='reg-header-inner'>
                <div className='logo-container'>
                  <img alt='' src={logo} className='logo-img' />
                </div>
                <div className='header-text'>WITMEG Customer Registration</div>
              </div>
            </div>
            <div className='reg-selection'>
              <div className='reg-slct-inner'>
                <div className='reg-slct-inner-head'>Welcome!</div>
                <div className='reg-slct-inner-sub'>
                  Whether you're joining us for the first-time or returning to
                  your account. we've got you covered
                </div>
                <div className='selection-cont'>
                  <div className='selction-cont-left'>
                    <div className='selction-cont-left-head'>I'm New Here</div>
                    <div className='selction-cont-left-sub'>
                      Create a new account and start exploring all the features
                      we have to offer.
                    </div>
                  </div>
                  <Button
                    text='Register'
                    onClick={() => {
                      navigate("/customer/register");
                    }}
                    isPrimary
                  />
                </div>
                <div className='selection-cont-bt'>
                  <div className='selction-cont-left'>
                    <div className='selction-cont-left-head'>
                      I'm Already Registered
                    </div>
                    <div className='selction-cont-left-sub'>
                      Access your account with verification
                    </div>
                  </div>
                  <Button
                    text='Verify'
                    onClick={() => {
                      navigate("/customer/verification");
                    }}
                    isPrimary={false}
                    isBorder
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CustomerRegister;
